import styles from "./page.module.css";
import { useNavigate } from "react-router-dom";
const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <style>
        @import
        url('https://fonts.googleapis.com/css2?family=Jost:wght@200;300;400&display=swap');
      </style>

      <div className={styles.designsection}>
        <div style={{ marginBottom: "50px", color: "white" }}>
          <h1>How our application works !</h1>
        </div>
        <div className={styles.timeline}>
          <div className={styles.timelineempty}></div>

          <div className={styles.timelinemiddle}>
            <div className={styles.timelinecircle}></div>
          </div>
          <div className={styles.timelinecomponent}>
            <div className={styles.timelinecontent}>
              <h3>1st</h3>
              <p>
                {" "}
                we take user account address and email and send it to our
                websocket{" "}
              </p>
            </div>
          </div>
          <div className={styles.timelinecomponent}>
            <div className={styles.timelinecontent}>
              <h3>2nd</h3>
              <p>
                {" "}
                our websocket continuously check if the value of coin in the
                user account touched the thresold value or not
              </p>
            </div>
          </div>
          <div className={styles.timelinemiddle}>
            <div className={styles.timelinecircle}></div>
          </div>
          <div className={styles.timelineempty}></div>

          <div className={styles.timelineempty}></div>

          <div className={styles.timelinemiddle}>
            <div className={styles.timelinecircle}></div>
          </div>
          <div className={styles.timelinecomponent}>
            <div className={styles.timelinecontent}>
              <h3>3rd</h3>
              <p>
                {" "}
                when the write condition meet our server send user the email
                that their coin touched the thresold value
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            margin: "200px 0px",
          }}
        >
          {" "}
          <button
            className={styles.btnforhome}
            onClick={() => {
              navigate("/form");
            }}
          >
            DEMO
          </button>
        </div>

        <div style={{ marginTop: "100px" }}>
          <div className={styles.timelinecomponent}>
            <div className={styles.timelinecontent}>
              <h3> Progress ?</h3>
              <p>
                because of continuos checking our app only works when thier is
                only one user our team is working how to make it work for
                multiple user
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
